import { Injectable } from '@angular/core';
import { HttpHeaders } from '@angular/common/http';
import { CommonService } from '../../../../shared/services/common.service';
import { Observable } from 'rxjs';
import { environment } from '../../../../../environments/environment';
import { API_ENDPOINTS } from '../../../../core/services/api.service';

@Injectable({
  providedIn: 'root'
})
export class UserService {

  constructor(private commonSvc: CommonService) { }
  getUsersbyCustomerId(customer_id: string): Observable<any> {
    const headers = new HttpHeaders({ 'x-customer-id': customer_id });
    return this.commonSvc.httpSvc.get<any>(environment.apiBaseUrl + API_ENDPOINTS.CUSTOMER.USER.LISTING, headers);
  }

   getUserById(user_id: string | number): Observable<any> {
    return this.commonSvc.httpSvc.getById<any>(environment.apiBaseUrl + API_ENDPOINTS.CUSTOMER.USER.BY_ID, user_id);
  }

  addUser(data: any): Observable<any> {
    return this.commonSvc.httpSvc.post<any>(environment.apiBaseUrl + API_ENDPOINTS.CUSTOMER.USER.ADD, data);
  }

  addUserExcel(data: any): Observable<any> {
    return this.commonSvc.httpSvc.postFile<any>(environment.apiBaseUrl + API_ENDPOINTS.CUSTOMER.USER.ADD_EXCEL, data);
  }

  updateUser(user_id: string | number, data: any): Observable<any> {
    return this.commonSvc.httpSvc.patch<any>(environment.apiBaseUrl + API_ENDPOINTS.CUSTOMER.USER.UPDATE, user_id, data);
  }

  getLocationCheckForUser(data: any): Observable<any> {
    return this.commonSvc.httpSvc.get<any>(environment.apiBaseUrl + API_ENDPOINTS.CUSTOMER.USER.LOCATION_ACCESS + data.customer_id + '/' + data.user_id)
  }

  deleteUser(data: any): Observable<any> {
    return this.commonSvc.httpSvc.post<any>(environment.apiBaseUrl + API_ENDPOINTS.CUSTOMER.USER.DELETE, data)
  }

  updateUserStatus(data: any): Observable<any> {
    return this.commonSvc.httpSvc.put<any>(environment.apiBaseUrl + API_ENDPOINTS.CUSTOMER.USER.UPDATE_LOCATIONS, data);
  }

  getUserRole(customer_id: any): Observable<any> {
    const headers = new HttpHeaders({ 'x-customer-id': customer_id });
    return this.commonSvc.httpSvc.get<any>(environment.apiBaseUrl + API_ENDPOINTS.CUSTOMER.USER.GET_ROLES, headers);
  }

  addUserRole(data: any): Observable<any> {
    return this.commonSvc.httpSvc.post<any>(environment.apiBaseUrl + API_ENDPOINTS.CUSTOMER.USER.ADD_ROLE, data);
  }

  resetUserPassword(data: any): Observable<any> {
    return this.commonSvc.httpSvc.post<any>(environment.apiBaseUrl + API_ENDPOINTS.CUSTOMER.USER.RESET_PASSWORD, data);
  }
}

